import { Button, ButtonProps } from 'primereact/button'

import { pi } from '../common/pure/PrimeIcon'
import t from '../../tools/t'

interface FlowCardActionProps extends ButtonProps {}
const FlowCardAction = (props: FlowCardActionProps) => (
    <Button className="flow-card__action" {...props} />
)

export const FlowCardCancelAction = (props: FlowCardActionProps) => (
    <FlowCardAction {...props} severity="secondary" outlined label={t('common_cancel')} />
)

export const FlowCardNextAction = (props: FlowCardActionProps) => (
    <FlowCardAction
        {...props}
        icon={pi('chevron-right')}
        iconPos="right"
        label={t('common_next_step')}
    />
)

export const FlowCardDoneAction = (props: FlowCardActionProps) => (
    <FlowCardAction {...props} label={t('common_done')} />
)
